import React from 'react'
import { AiAppCard } from '@/components/ai/AiAppCard'

export default function SponsorAiApp() {
  return (
    <section className="space-y-4">
      <AiAppCard
        title="Sponsor Impact Story"
        subtitle="Deep-dive app that pulls your giving history, teacher updates, and classroom photos into a share-ready story."
        ctaLabel="Open (coming soon)"
        onClick={() => {}}
      />
    </section>
  )
}
